export var CONTRACT_STATEMENT = "CONTRACT_STATEMENT";
